import { Badge } from '@monksflow/monks-ui';
import { microInteraction } from '@/shared/ui/MicroInteractions';
import { taxonomyStatusLabel } from '../../lib/statusLabel';
import type { TaxonomyStatus } from '../../model/types';

type BadgeVariant = 'default' | 'secondary' | 'warning' | 'positive' | 'destructive';

const UNKNOWN_READS_AS: TaxonomyStatus = 'draft';

const VARIANTS: Record<TaxonomyStatus, BadgeVariant> = {
  draft: 'default',
  published: 'positive',
  archived: 'secondary',
};

export interface TaxonomyStatusBadgeProps {
  status: TaxonomyStatus | null | undefined;
}

export function TaxonomyStatusBadge({ status }: TaxonomyStatusBadgeProps) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- VARIANTS is indexed, so a status outside the map reads as present
  const known = status && VARIANTS[status] ? status : UNKNOWN_READS_AS;

  return (
    <Badge variant={VARIANTS[known]} roundness="full" className={microInteraction.statusBadge}>
      {taxonomyStatusLabel(known)}
    </Badge>
  );
}

TaxonomyStatusBadge.displayName = 'TaxonomyStatusBadge';
